import { TranslatePipe } from '@ngx-translate/core';
import { LanguageService } from '../../core/i18n/language.service';
import { Component, inject } from '@angular/core';
import { RouterLink } from '@angular/router';
import { ResponsiveImageDirective } from '../../shared/directives/responsive-image.directive';

@Component({
  selector: 'app-surroundings', imports: [TranslatePipe, RouterLink, ResponsiveImageDirective],
  template: `<article class="editorial-page">
    <nav [attr.aria-label]="'surroundings.breadcrumbs' | translate"><a [routerLink]="language.path('home')">{{ 'common.home' | translate }}</a> / {{ 'common.surroundings' | translate }}</nav>
    <p class="eyebrow">BETHAUSEN · TIMIȘ</p>
    <h1>{{ 'surroundings.title' | translate }}</h1>
    <p class="lead">{{ 'surroundings.intro' | translate }}</p>
    <img sohImage="/assets/picaroo/bega_1200x1600.webp" sizes="(max-width: 900px) 92vw, 900px" [alt]="'surroundings.photoAlt' | translate" fetchpriority="high" />
    <h2>{{ 'surroundings.day1Title' | translate }}</h2>
    <p>{{ 'surroundings.day1Morning' | translate }}</p>
    <p>{{ 'surroundings.day1Evening' | translate }}</p>
    <h2>{{ 'surroundings.day2Title' | translate }}</h2>
    <p>{{ 'surroundings.day2Trips' | translate }}</p>
    <p>{{ 'surroundings.day2Advice' | translate }}</p>
    <h2>{{ 'surroundings.villageTitle' | translate }}</h2>
    <p>{{ 'surroundings.village' | translate }}</p>
    <h2>{{ 'surroundings.planningTitle' | translate }}</h2>
    <ul><li>{{ 'surroundings.chooseDates' | translate }}</li>
      <li>{{ 'surroundings.read' | translate }} <a [routerLink]="language.path('about')">{{ 'surroundings.facilities' | translate }}</a> {{ 'surroundings.beforeBooking' | translate }}</li>
      <li>{{ 'surroundings.weather' | translate }}</li>
      <li>{{ 'surroundings.use' | translate }} <a [routerLink]="language.path('contact')" fragment="indicatii">{{ 'surroundings.directions' | translate }}</a> {{ 'surroundings.address' | translate }}</li></ul>
    <p>{{ 'surroundings.stayIn' | translate }}</p>
    <a class="editorial-cta" [routerLink]="language.path('contact')" fragment="rezervare">{{ 'surroundings.bookingLink' | translate }}</a>
  </article>`
})
export class SurroundingsComponent {
  readonly language = inject(LanguageService);
}
